export const translations = {
  sv: {
    // Navigation
    features: "Funktioner",
    about: "Om oss",
    privacy: "Sekretess",
    support: "Support",

    // Hero Section
    heroTitle: "Att spåra din tarmhälsa har aldrig varit enklare",
    heroSubtitle:
      "Belly Flow hjälper dig att logga och övervaka dina magrelaterade besvär på ett enkelt och snabbt sätt. Få insikter om dina trender och förbättra din hälsa.",
    downloadApp: "Ladda ner appen",
    readMore: "Läs mer",

    // Features Section
    featuresTitle: "Funktioner",
    simpleLogging: "Enkel loggning",
    simpleLoggingDesc:
      "Logga dina symptom och besvär på sekunder med vår intuitiva app",
    trendsAnalysis: "Trender och analys",
    trendsAnalysisDesc:
      "Se mönster i din hälsa över tid med tydliga grafer och rapporter",
    securePrivate: "Säker och privat",
    securePrivateDesc:
      "Din data är säker hos oss med kryptering och strikta sekretessregler",
    research: "Forskning",
    researchDesc:
      "Bidra till medicinsk forskning om tarmhälsa med anonymiserad data",

    // About Section
    aboutTitle: "Om Belly Flow",
    aboutDesc1:
      "Belly Flow är utvecklat för att hjälpa personer med magrelaterade besvär att bättre förstå sin hälsa. Genom enkel loggning och tydlig visualisering kan du identifiera mönster som kan hjälpa dig och din läkare.",
    aboutDesc2:
      "Vår app följer de högsta standarderna för säkerhet och sekretess, och din anonymiserade data kan bidra till viktig medicinsk forskning.",

    // CTA Section
    ctaTitle: "Redo att börja?",
    ctaSubtitle: "Ladda ner Belly Flow idag och ta kontroll över din tarmhälsa",
    downloadNow: "Ladda ner nu",

    // Footer
    footerDescription:
      "Appen som hjälper dig att förstå och förbättra din tarmhälsa",
    links: "Länkar",
    contact: "Kontakt",
    copyright: "© 2026 Belly Flow. Alla rättigheter förbehållna.",

    // Language switcher
    language: "Språk",
    english: "English",
    swedish: "Svenska",

    // Privacy Policy Page
    backToBellyFlow: "← Tillbaka till Belly Flow",
    privacyPolicyTitle: "Sekretesspolicy - Belly Flow",
    validFrom: "Giltig från:",
    lastUpdated: "Senast uppdaterad:",
    introduction: "Introduktion",
    introductionText:
      "Vi respekterar din integritet och skyddar din personliga data. Här förklarar vi hur vi hanterar din information när du använder Belly Flow.",
    informationWeCollect: "Information vi samlar in",
    dataLinkedToIdentity: "Data kopplad till din identitet",
    emailAddress: "E-postadress",
    usedFor: "Används för:",
    accountCreation:
      "Kontoskapande, autentisering och väsentlig app-funktionalitet",
    emailDescription:
      "Vi samlar in din e-postadress för att skapa och hantera ditt konto, skicka lösenordsåterställningslänkar och viktiga app-meddelanden.",
    userContent: "Användarinnehåll",
    customerSupport:
      "Kundsupport-interaktioner och användargenererat innehåll i appen",
    userContentDescription:
      "När du kontaktar vår kundsupport kan vi samla in information om dina frågor och problem för att bättre hjälpa dig.",
    dataNotLinkedToIdentity: "Data inte kopplad till din identitet",
    healthFitnessData: "Hälsodata",
    appFunctionality: "App-funktionalitet och forskning",
    healthDataDescription: "Vi samlar in hälsorelaterad information inklusive:",
    gutSymptoms: "Tarmsymptom (IBS-symptom, smärtnivåer, etc.)",
    bristolStool: "Bristol Stool Scale-bedömningar",
    dietInfo: "Kostinformation och wellness-mätvärden",
    symptomDates: "Datum och tid för symptomregistrering",
    personalNotes: "Personliga anteckningar om dina symptom",
    contactInfo: "Kontaktinformation",
    technicalSupport: "Teknisk support-kommunikation",
    contactInfoDescription:
      "Vi kan samla in kontaktinformation för teknisk support och kundtjänstsyften.",
    howWeUseYourInformation: "Hur vi använder din information",
    primaryUseCases: "Primära användningsområden",
    appFunctionalityDescription:
      "För att tillhandahålla kärnfunktioner, användarautentisering och personlig hälsospårning",
    customerSupportDescription:
      "För att svara på dina förfrågningar och tillhandahålla teknisk assistans",
    analysis: "Analys",
    analysisDescription:
      "För att förbättra app-prestanda och användarupplevelse",
    researchContributions: "Forskningsbidrag",
    importantNotice: "Viktigt",
    researchContributionDescription:
      "Din anonymiserade hälsa- och fitness-data kan bidra till vetenskaplig forskning som syftar till att främja förståelse för tarmhälsa. Denna forskning hjälper till att:",
    identifyPatterns: "Identifiera mönster i tarmhälsa och wellness",
    developBetterRecommendations: "Utveckla bättre hälsorekommendationer",
    promoteScientificKnowledge:
      "Främja vetenskaplig kunskap om matsmältningshälsa",
    supportBroaderMedicalResearch:
      "Stödja det bredare medicinska forskningssamhället",
    criticalNotice: "Observera",
    anonymizedDataOnly:
      "Endast anonymiserad, de-identifierad data används för forskningssyften. Din personliga identitet kan inte bestämmas från denna forskningsdata.",
    dataProtection: "Dataskydd",
    securityMeasures: "Säkerhetsåtgärder",
    secureDatabase:
      "Din data lagras i säkra, krypterade databaser",
    allDataEncrypted: "All data är krypterad under överföring via HTTPS",
    strictAccessToPersonalData:
      "Åtkomst till personlig data är strikt begränsad till auktoriserad personal",
    followsStandards:
      "Vi följer branschstandarder för säkerhet och GDPR",
    dataAnonymization: "Dataanonymisering",
    anonymizationDescription:
      "Hälsa- och fitness-data som används för forskning är noggrant anonymiserad genom:",
    removeAllPersonalIdentifiers:
      "Borttagning av alla personliga identifierare",
    dataAggregationTechniques: "Dataaggregeringstekniker",
    statisticalAnonymizationMethods: "Statistiska anonymiseringsmetoder",
    regularAuditOfAnonymizationProcesses:
      "Regelbunden granskning av anonymiseringsprocesser",
    yourRightsAndChoices: "Dina rättigheter och val",
    yourRights: "Du har rätt att",
    accessYourPersonalData: "Komma åt din personliga data",
    correctIncorrectInformation: "Korrigera felaktig information",
    deleteYourAccount: "Radera ditt konto och associerad data",
    optOutOfResearchContributions: "Välja bort forskningsdatabidrag",
    withdrawConsentAtAnyTime: "Återkalla samtycke när som helst",
    dataStorage: "Datalagring",
    accountData: "Kontodata",
    accountDataDescription: "Behålls medan ditt konto är aktivt",
    anonymizedResearchData: "Anonymiserad forskningsdata",
    anonymizedResearchDataDescription:
      "Kan behållas på obestämd tid för forskningssyften",
    personalIdentifiers: "Personliga identifierare",
    personalIdentifiersDescription: "Raderas vid kontoterminering",
    thirdPartyServices: "Tredjepartstjänster",
    thirdPartyServicesDescription:
      "Vi kan använda betrodda tredjepartstjänster för",
    dataStorageAndProcessing:
      "Datalagring och bearbetning (GDPR-kompatibla tjänster)",
    analysisAndAppPerformanceMonitoring: "Analys och app-prestandaövervakning",
    customerSupportSystem: "Kundsupportsystem",
    hostingServices: "Hostingtjänster (Vercel - GDPR-kompatibel)",
    allThirdPartiesMustMaintain:
      "Alla tredjeparter måste upprätthålla motsvarande sekretessstandarder.",
    childrensPrivacy: "Barns sekretess",
    childrensPrivacyDescription:
      "Denna app är inte avsedd för barn under 16 år. Vi samlar inte medvetet in personlig information från barn under 16 år.",
    internationalDataTransfers: "Internationella dataöverföringar",
    internationalDataTransfersDescription:
      "Din data kan bearbetas i länder andra än ditt eget. Vi säkerställer att lämpliga skyddsåtgärder finns på plats för internationella överföringar.",
    policyChanges: "Ändringar i denna policy",
    policyChangesDescription:
      "Vi kan uppdatera denna sekretesspolicy periodiskt. Vi kommer att meddela användare om betydande ändringar genom appen eller e-post.",
    researchEthics: "Forskningsetik",
    researchEthicsDescription:
      "Våra forskningsaktiviteter följer etablerade etiska riktlinjer",
    institutionalReviewBoardSupervision:
      "Institutionell granskningsnämnds tillsyn",
    complianceWithMedicalResearchEthicsStandards:
      "Efterlevnad av medicinsk forskningsetik-standarder",
    commitmentToBeneficialResearchResults:
      "Engagemang för gynnsamma forskningsresultat",
    transparencyInResearchMethodologies: "Transparens i forskningsmetodologier",
    contactUsDescription: "För frågor om denna sekretesspolicy eller din data",
    email: "E-post",
    consent: "Samtycke",
    consentDescription:
      "Genom att använda denna app samtycker du till insamling och användning av din information som beskrivs i denna sekretesspolicy, inklusive användning av anonymiserad data för tarmhälsa-forskningssyften.",
    compliance: "Efterlevnad",
    complianceDescription:
      "Denna sekretesspolicy följer tillämpliga sekretesslagar inklusive GDPR, CCPA och Apple App Store-krav.",

    // Support Page
    supportTitle: "Support & Hjälp",
    supportSubtitle:
      "Vi är här för att hjälpa dig få ut mesta möjliga av Belly Flow",
    contactUs: "Kontakta oss",
    emailSupport: "E-post Support",
    supportHours: "Supporttider",
    mondayFriday: "Måndag - Fredag: 9:00 - 17:00 CET",
    weekends: "Helger: 10:00 - 16:00 CET",
    supportLanguages: "Vi erbjuder support på svenska och engelska",
    frequentlyAskedQuestions: "Vanliga frågor (FAQ)",
    howToCreateAccount: "Hur skapar jag ett konto?",
    accountCreationAnswer:
      "Ladda ner appen från App Store eller Google Play, öppna den och följ instruktionerna för att skapa ditt konto med din e-postadress.",
    howToLogSymptoms: "Hur loggar jag mina symptom?",
    symptomLoggingAnswer:
      "I appen kan du enkelt logga dina symptom genom att välja från fördefinierade alternativ eller lägga till egna anteckningar. Du kan också använda Bristol Stool Scale för att bedöma din tarmhälsa.",
    isMyDataSafe: "Är min data säker?",
    dataSafetyAnswer:
      "Din data lagras i säkra, krypterade databaser som följer GDPR-regler. All kommunikation sker via krypterade anslutningar och du har full kontroll över din information.",
    canIExportData: "Kan jag exportera min data?",
    dataExportAnswer:
      "Ja, du kan exportera din data när som helst i olika format. Detta är användbart om du vill dela information med din läkare eller bara ha en backup.",
    responseTime: "Vi svarar normalt inom 24 timmar",
    howDoesResearchGrantWork: "Hur fungerar forskningsbidraget?",
    researchGrantAnswer:
      "Din anonymiserade data kan bidra till medicinsk forskning om tarmhälsa. Du kan när som helst välja att delta eller avsluta ditt bidrag. Läs mer i vår sekretesspolicy.",
    appFeatures: "App-funktioner",
    easyLogging: "Enkel loggning",
    easyLoggingDescription:
      "Logga symptom, kost och wellness-mätvärden på sekunder",
    analysisAndTrends: "Analys & Trender",
    analysisAndTrendsDescription:
      "Se mönster i din hälsa över tid med tydliga grafer",
    reminders: "Påminnelser",
    remindersDescription: "Ställ in påminnelser för att inte glömma att logga",
    export: "Export",
    exportDescription: "Exportera din data för att dela med läkare",
    security: "Säkerhet",
    securityDescription:
      "Krypterad datalagring och säker autentisering",
    languages: "Språk",
    languagesDescription: "Tillgänglig på svenska, engelska, portugisiska och spanska",
    troubleshooting: "Felsökning",
    appDoesNotStart: "Appen startar inte",
    checkLatestAppVersion: "Kontrollera att du har senaste versionen av appen",
    restartPhone: "Starta om din telefon",
    checkInternetConnection: "Kontrollera att du har internetanslutning",
    cannotLogIn: "Kan inte logga in",
    checkEmailAddress: "Kontrollera att din e-postadress är korrekt",
    useForgotPassword: 'Använd "Glömt lösenord" om du inte kommer ihåg det',
    checkIfEmailBlocked:
      "Kontrollera att du inte har blockerat e-post från oss",
    dataNotVisible: "Data syns inte",
    checkCorrectAccount: "Kontrollera att du är inloggad på rätt konto",
    syncAppByPullingDown: "Synkronisera appen genom att dra neråt",
    giveFeedback: "Ge feedback",
    appreciateFeedback:
      "Vi uppskattar all feedback som hjälper oss att förbättra Belly Flow! ",
    sendSuggestions:
      "Skicka dina förslag, buggrapporter eller kommentarer till ",
    supportEmail: "support@bellyflow.se",
    bugReport: "Buggrapport",
    reportProblems: "Rapportera problem eller fel i appen",
    suggestions: "Förslag",
    shareIdeas: "Dela dina idéer för nya funktioner",
    review: "Recension",
    leaveReview: "Lämna en recension i App Store eller Google Play",
    downloadBellyFlow: "Ladda ner Belly Flow",
    readyToStartJourney: "Redo att börja din resa mot bättre tarmhälsa?",
    downloadFrom: "Ladda ner från",
    appStore: "App Store",
    googlePlay: "Google Play",
  },

  en: {
    // Navigation
    features: "Features",
    about: "About",
    privacy: "Privacy",
    support: "Support",

    // Hero Section
    heroTitle: "Tracking your gut health has never been easier",
    heroSubtitle:
      "Belly Flow helps you log and monitor your gut-related issues in a simple and fast way. Get insights about your trends and improve your health.",
    downloadApp: "Download App",
    readMore: "Learn More",

    // Features Section
    featuresTitle: "Features",
    simpleLogging: "Simple Logging",
    simpleLoggingDesc:
      "Log your symptoms and issues in seconds with our intuitive app",
    trendsAnalysis: "Trends & Analysis",
    trendsAnalysisDesc:
      "See patterns in your health over time with clear graphs and reports",
    securePrivate: "Secure & Private",
    securePrivateDesc:
      "Your data is safe with us with encryption and strict privacy rules",
    research: "Research",
    researchDesc:
      "Contribute to medical research on gut health with anonymized data",

    // About Section
    aboutTitle: "About Belly Flow",
    aboutDesc1:
      "Belly Flow is developed to help people with gut-related issues better understand their health. Through simple logging and clear visualization, you can identify patterns that can help you and your doctor.",
    aboutDesc2:
      "Our app follows the highest standards for security and privacy, and your anonymized data can contribute to important medical research.",

    // CTA Section
    ctaTitle: "Ready to get started?",
    ctaSubtitle:
      "Download Belly Flow today and take control of your gut health",
    downloadNow: "Download Now",

    // Footer
    footerDescription:
      "The app that helps you understand and improve your gut health",
    links: "Links",
    contact: "Contact",
    copyright: "© 2026 Belly Flow. All rights reserved.",

    // Language switcher
    language: "Language",
    english: "English",
    swedish: "Svenska",

    // Privacy Policy Page
    backToBellyFlow: "← Back to Belly Flow",
    privacyPolicyTitle: "Privacy Policy - Belly Flow",
    validFrom: "Valid from:",
    lastUpdated: "Last updated:",
    introduction: "Introduction",
    introductionText:
      "We respect your privacy and protect your personal data. Here we explain how we handle your information when you use Belly Flow.",
    informationWeCollect: "Information we collect",
    dataLinkedToIdentity: "Data linked to your identity",
    emailAddress: "Email address",
    usedFor: "Used for:",
    accountCreation:
      "Account creation, authentication, and essential app functionality",
    emailDescription:
      "We collect your email address to create and manage your account, send password reset links, and important app notifications.",
    userContent: "User content",
    customerSupport:
      "Customer support interactions and user-generated content in the app",
    userContentDescription:
      "When you contact our customer support, we may collect information about your questions and issues to better help you.",
    dataNotLinkedToIdentity: "Data not linked to your identity",
    healthFitnessData: "Health data",
    appFunctionality: "App functionality and research",
    healthDataDescription: "We collect health-related information including:",
    gutSymptoms: "Gut symptoms (IBS symptoms, pain levels, etc.)",
    bristolStool: "Bristol Stool Scale assessments",
    dietInfo: "Diet information and wellness metrics",
    symptomDates: "Dates and times of symptom recordings",
    personalNotes: "Personal notes about your symptoms",
    contactInfo: "Contact information",
    technicalSupport: "Technical support communication",
    contactInfoDescription:
      "We may collect contact information for technical support and kundtjänstsyften.",
    howWeUseYourInformation: "How we use your information",
    primaryUseCases: "Primary use cases",
    appFunctionalityDescription:
      "To provide core functions, user authentication, and personal health tracking",
    customerSupportDescription:
      "To respond to your inquiries and provide technical assistance",
    analysis: "Analysis",
    analysisDescription: "To improve app performance and user experience",
    researchContributions: "Research contributions",
    importantNotice: "Important",
    researchContributionDescription:
      "Your anonymized health and fitness data can contribute to scientific research aimed at promoting understanding of gut health. This research helps to:",
    identifyPatterns: "Identify patterns in gut health and wellness",
    developBetterRecommendations: "Develop better health recommendations",
    promoteScientificKnowledge:
      "Promote scientific knowledge about digestive health",
    supportBroaderMedicalResearch: "Support broader medical research community",
    criticalNotice: "Note",
    anonymizedDataOnly:
      "Only anonymized, de-identified data is used for research purposes. Your personal identity cannot be determined from this research data.",
    dataProtection: "Data protection",
    securityMeasures: "Security measures",
    secureDatabase:
      "Your data is stored in secure, encrypted databases",
    allDataEncrypted: "All data is encrypted during transmission via HTTPS",
    strictAccessToPersonalData:
      "Access to personal data is strictly limited to authorized personnel",
    followsStandards:
      "We follow industry standards for security and GDPR",
    dataAnonymization: "Data anonymization",
    anonymizationDescription:
      "Health and fitness data used for research are thoroughly anonymized through:",
    removeAllPersonalIdentifiers: "Removal of all personal identifiers",
    dataAggregationTechniques: "Data aggregation techniques",
    statisticalAnonymizationMethods: "Statistical anonymization methods",
    regularAuditOfAnonymizationProcesses:
      "Regular audits of anonymization processes",
    yourRightsAndChoices: "Your rights and choices",
    yourRights: "You have the right to",
    accessYourPersonalData: "Access your personal data",
    correctIncorrectInformation: "Correct incorrect information",
    deleteYourAccount: "Delete your account and associated data",
    optOutOfResearchContributions: "Opt out of research contributions",
    withdrawConsentAtAnyTime: "Withdraw consent at any time",
    dataStorage: "Data storage",
    accountData: "Account data",
    accountDataDescription: "Stored while your account is active",
    anonymizedResearchData: "Anonymized research data",
    anonymizedResearchDataDescription:
      "Can be retained indefinitely for research purposes",
    personalIdentifiers: "Personal identifiers",
    personalIdentifiersDescription: "Deleted upon account termination",
    thirdPartyServices: "Third-party services",
    thirdPartyServicesDescription:
      "We may use trusted third-party services for",
    dataStorageAndProcessing:
      "Data storage and processing (GDPR compliant services)",
    analysisAndAppPerformanceMonitoring:
      "Analysis and app performance monitoring",
    customerSupportSystem: "Customer support system",
    hostingServices: "Hosting services (Vercel - GDPR compliant)",
    allThirdPartiesMustMaintain:
      "All third parties must maintain equivalent privacy standards.",
    childrensPrivacy: "Children's privacy",
    childrensPrivacyDescription:
      "This app is not intended for children under 16 years of age. We do not knowingly collect personal information from children under 16 years of age.",
    internationalDataTransfers: "International data transfers",
    internationalDataTransfersDescription:
      "Your data may be processed in countries other than your own. We ensure that appropriate safeguards are in place for international transfers.",
    policyChanges: "Changes to this policy",
    policyChangesDescription:
      "We may update this privacy policy periodically. We will notify users of significant changes through the app or email.",
    researchEthics: "Research ethics",
    researchEthicsDescription:
      "Our research activities follow established ethical guidelines",
    institutionalReviewBoardSupervision:
      "Institutional review board supervision",
    complianceWithMedicalResearchEthicsStandards:
      "Compliance with medical research ethics standards",
    commitmentToBeneficialResearchResults:
      "Commitment to beneficial research results",
    transparencyInResearchMethodologies:
      "Transparency in research methodologies",
    contactUsDescription:
      "For questions about this privacy policy or your data",
    email: "Email",
    consent: "Consent",
    consentDescription:
      "By using this app, you consent to the collection and use of your information as described in this privacy policy, including the use of anonymized data for gut health research purposes.",
    compliance: "Compliance",
    complianceDescription:
      "This privacy policy follows applicable privacy laws including GDPR, CCPA, and Apple App Store requirements.",

    // Support Page
    supportTitle: "Support & Help",
    supportSubtitle: "We're here to help you get the most out of Belly Flow",
    contactUs: "Contact us",
    emailSupport: "Email Support",
    supportHours: "Support hours",
    mondayFriday: "Monday - Friday: 9:00 - 17:00 CET",
    weekends: "Weekends: 10:00 - 16:00 CET",
    supportLanguages: "We offer support in Swedish and English",
    frequentlyAskedQuestions: "Frequently Asked Questions (FAQ)",
    howToCreateAccount: "How do I create an account?",
    accountCreationAnswer:
      "Download the app from the App Store or Google Play, open it and follow the instructions to create your account with your email address.",
    howToLogSymptoms: "How do I log my symptoms?",
    symptomLoggingAnswer:
      "In the app, you can easily log your symptoms by choosing from predefined options or adding your own notes. You can also use the Bristol Stool Scale to assess your gut health.",
    isMyDataSafe: "Is my data safe?",
    dataSafetyAnswer:
      "Your data is stored in secure, encrypted databases that follow GDPR regulations. All communication is encrypted and you have full control over your information.",
    canIExportData: "Can I export my data?",
    dataExportAnswer:
      "Yes, you can export your data at any time in various formats. This is useful if you want to share information with your doctor or just have a backup.",
    responseTime: "We normally respond within 24 hours",
    howDoesResearchGrantWork: "How does research grant work?",
    researchGrantAnswer:
      "Your anonymized data can contribute to medical research on gut health. You can at any time choose to participate or withdraw your contribution. Read more in our privacy policy.",
    appFeatures: "App features",
    easyLogging: "Easy logging",
    easyLoggingDescription:
      "Log symptoms, diet, and wellness metrics in seconds",
    analysisAndTrends: "Analysis & Trends",
    analysisAndTrendsDescription:
      "See patterns in your health over time with clear graphs",
    reminders: "Reminders",
    remindersDescription: "Set reminders to not forget to log",
    export: "Export",
    exportDescription: "Export your data to share with your doctor",
    security: "Security",
    securityDescription:
      "Encrypted data storage and secure authentication",
    languages: "Languages",
    languagesDescription: "Available in Swedish, English, Portuguese and Spanish",
    troubleshooting: "Troubleshooting",
    appDoesNotStart: "App does not start",
    checkLatestAppVersion: "Check if you have the latest app version",
    restartPhone: "Restart your phone",
    checkInternetConnection: "Check if you have an internet connection",
    cannotLogIn: "Cannot log in",
    checkEmailAddress: "Check if your email address is correct",
    useForgotPassword: 'Use "Forgot password" if you don\'t remember it',
    checkIfEmailBlocked: "Check if you have blocked emails from us",
    dataNotVisible: "Data is not visible",
    checkCorrectAccount: "Check if you are logged in to the correct account",
    syncAppByPullingDown: "Sync the app by pulling down",
    giveFeedback: "Give feedback",
    appreciateFeedback:
      "We appreciate all feedback that helps us improve Belly Flow! ",
    sendSuggestions: "Send your suggestions, bug reports, or comments to ",
    supportEmail: "support@bellyflow.se",
    bugReport: "Bug report",
    reportProblems: "Report problems or bugs in the app",
    suggestions: "Suggestions",
    shareIdeas: "Share your ideas for new features",
    review: "Review",
    leaveReview: "Leave a review in the App Store or Google Play",
    downloadBellyFlow: "Download Belly Flow",
    readyToStartJourney:
      "Ready to start your journey towards better gut health?",
    downloadFrom: "Download from",
    appStore: "App Store",
    googlePlay: "Google Play",
  },
};
